import React, { useContext, createContext, useState } from "react";

const activeArticleContext = createContext();

export const useActiveArticle = () => useContext(activeArticleContext);

export const ActiveArticleProvider = ({ children }) => {
  const [activeArticle, setActiveArticle] = useState(-1);

  return (
    <activeArticleContext.Provider value={[activeArticle, setActiveArticle]}>
      {children}
    </activeArticleContext.Provider>
  );
};
